import React from 'react';
import {
  PlusOutlined,
  DeleteOutlined,
  CalendarOutlined,
  FileTextOutlined,
  FolderOutlined,
  TagsOutlined,
  AppstoreOutlined,
  StarOutlined,
  FormOutlined,
  TrophyOutlined,
  EditOutlined,
  SettingOutlined,
  SaveOutlined,
  FilterOutlined,
  UpOutlined,
  DownOutlined,
  GlobalOutlined,
  SearchOutlined,
  MinusCircleOutlined,
  GiftOutlined,
  TeamOutlined,
  ReloadOutlined,
  UploadOutlined,
  HeartOutlined,
  MessageOutlined,
} from '@ant-design/icons';

const typeToComponent = {
  plus: PlusOutlined,
  delete: DeleteOutlined,
  calendar: CalendarOutlined,
  snippets: FileTextOutlined,
  folder: FolderOutlined,
  tags: TagsOutlined,
  layout: AppstoreOutlined,
  star: StarOutlined,
  form: FormOutlined,
  trophy: TrophyOutlined,
  edit: EditOutlined,
  setting: SettingOutlined,
  save: SaveOutlined,
  filter: FilterOutlined,
  'arrow-up': UpOutlined,
  'arrow-down': DownOutlined,
  down: DownOutlined,
  global: GlobalOutlined,
  search: SearchOutlined,
  'minus-circle-o': MinusCircleOutlined,
  gift: GiftOutlined,
  team: TeamOutlined,
  reload: ReloadOutlined,
  upload: UploadOutlined,
  heart: HeartOutlined,
  message: MessageOutlined,
};

/**
 * Ant Design 4 compatible icon wrapper. Use type="plus", type="delete", etc.
 * Replaces the removed <Icon type="..." /> from antd 3.
 */
export default function AntIcon({ type, ...rest }) {
  const Component = typeToComponent[type] || PlusOutlined;
  return <Component {...rest} />;
}
